import { Component, PropsWithChildren } from "react";
import { noticeError } from "../newrelic/requests";

type ErrorProps = {
  componentName: string;
};

type ErrorState = {
  hasError: boolean;
};

export class ErrorBoundary extends Component<
  PropsWithChildren<ErrorProps>,
  ErrorState
> {
  constructor(props: ErrorProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  override componentDidCatch(error: Error, info: { componentStack: string }) {
    let message = "";
    if (error instanceof Error) {
      message = error.message;
    }

    noticeError(
      `Error while rendering the ${this.props.componentName} component`,
      {
        message,
        stack: info.componentStack,
      },
    );
  }

  override render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return null;
    }

    return this.props.children;
  }
}
